import * as PIXI from 'pixi.js'
import * as TWEEN from 'es6-tween'
import Events from '@/events'
import { Easing, Tween } from 'es6-tween'
PIXI.utils.skipHello()

let WIDTH = 1440
let HEIGHT = 812

class Ripple {

	constructor(x, y, texture) {
		this.sprite = new PIXI.Sprite(texture)
		this.sprite.anchor.set(0.5)
		this.sprite.position.set(x, y)
		this.sprite.scale.set(Math.random() / 100)
		this.filter = new PIXI.filters.DisplacementFilter(this.sprite)
		return this
	}

	update() {
		this.sprite.scale.x += 0.02
		this.sprite.scale.y += 0.02
	}

}

export default {

	async init(el, started, next, mobile) {
		
		this.width = window.innerWidth
		this.height = window.innerHeight

		this.scale = this.calcScale()
		this.startedMask = false

		this.next = next
		this.mobile = mobile
		this.started = started
		this.lastPos = 0
		
		this.updates = []
		this.ripples = []


		let app = new PIXI.Application({
			width: this.width,
			height: this.height,
			transparent: true
		})
		let assets = await this.preload()
		Events.$emit('water-loaded')

		this.app = app
		this.stage = app.stage
		this.assets = assets
		let water = new PIXI.Sprite(assets['water'].texture)
		let waterBlur = new PIXI.Sprite(assets['water-blur'].texture)

		this.blur = waterBlur
		this.blur.alpha = 0

		this.bg1 = new PIXI.Sprite(assets['bg1'].texture)
		this.bg2 = new PIXI.Sprite(assets['bg2'].texture)
		this.bg3 = new PIXI.Sprite(assets['bg3'].texture)
		this.bg4 = new PIXI.Sprite(assets['bg4'].texture)

		this.bg1.alpha = 0
		this.bg2.alpha = 0
		this.bg3.alpha = 0
		this.bg4.alpha = 0

		let colors

		if (this.mobile) {
			colors = new PIXI.Sprite(assets['colors-mobile'].texture)
			colors.width = this.width
			colors.height = this.height
		} else {
			colors = new PIXI.Sprite(assets['colors'].texture)
		}

		let mask = new PIXI.Sprite(assets['mask'].texture)
		mask.anchor.set(0.5)

		let clouds = new PIXI.Sprite(assets['clouds'].texture)
		clouds.anchor.set(0.5)
		clouds.position.set(window.innerWidth / 2, window.innerHeight / 2)
		clouds.filter = new PIXI.filters.DisplacementFilter(clouds)
		this.clouds = clouds

		let colorsGroup = new PIXI.Container()
		colorsGroup.addChild(colors)
		colorsGroup.addChild(this.bg1)
		colorsGroup.addChild(this.bg2)
		colorsGroup.addChild(this.bg3)
		colorsGroup.addChild(this.bg4)

		app.stage.addChild(water)
		app.stage.addChild(waterBlur)
		app.stage.addChild(colorsGroup)
		app.stage.addChild(mask)
		app.stage.addChild(clouds)
		
		colorsGroup.mask = mask
		mask.alpha = 0
		this.mask = mask

		el.appendChild(app.view)
		
		this.applyFilters()
		
		app.stage.interactive = true
		app.stage.pointerdown = e => {

			if (this.disabled) return
			if (this.loading) return
			if (this.mouseDown) return
			this.mouseDown = true

			let { x, y } = e.data.global
			this.mask.position.set(x / this.scale, y / this.scale)

		}


		let count = 0
		let time = 0// mousemove
		app.stage.pointermove = e => {
			
			
			let { x, y } = e.data.global
			
			if (this.disabled) return
			if (this.loading) return
			this.calcPosition(x, y)

			if (count > 30) {
				this.addRipple(x / this.scale, y / this.scale)
				count = 0
			}
			count++
			
			if (this.mobile && !this.startedMask) {

				this.startedMask = true

				new Tween({a: 0})
					.to({a: 0.8}, 500)
					.on('update', ({ a }) => {
						this.mask.alpha = a
					})
					.start()

			} else {
				if (!this.startedMask && !this.timeout) {
					this.timeout = setTimeout(() => {
						this.startedMask = true
						this.mask.position.set(x / this.scale, y / this.scale)
						new Tween({a: 0})
							.to({a: 0.8}, 500)
							.on('update', ({ a }) => {
								this.mask.alpha = a
							})
							.start()
							}, 1000)
					return
				} else if (this.startedMask ) {
					clearTimeout(this.timeout)
				}
			}
			

			let scl = (Math.cos(time++ * 0.01) + 1) / 8 + 0.5
			this.mask.scale.set(scl)
			this.mask.rotation += 0.01
			this.mask.position.set(x / this.scale, y / this.scale)
			
			
		}


		app.stage.pointerup = e => {

			let { x, y } = e.data.global

			if (this.disabled) return
			if (this.loading) return

			if (!this.startedMask) {
				clearTimeout(this.timeout)
				this.mask.position.set(x / this.scale, y / this.scale)
				new Tween({a: 0})
					.to({a: 0.8}, 500)
					.on('update', ({ a }) => {
						this.mask.alpha = a
					})
					.start()
			}

			this.mouseDown = false
			this.startedMask = false
			this.showPreload()
			this.started()

		}


		PIXI.Ticker.shared.add(delta => {

			clouds.rotation += 0.01
			
			for (let i = 0; i < this.ripples.length; i++) {
				
				if (this.ripples[i].sprite.scale.x > 8) {
					this.destroyRipple(i)
				} else {
					this.ripples[i].update()
				}
			}

			if (this.loading) {
				let scl = Math.cos(time++ * 0.01) / 100 + this.mask.scale.x
				if (scl > 1) scl = 1
				if (scl < 0.8) scl = 0.8
				this.mask.scale.set(scl)
				this.mask.rotation += 0.01

				if (count > 50) {
					this.addRipple(this.width / 2 / this.scale, this.height / 2 / this.scale)
					count = 0
				}
				count++
			}

			TWEEN.update()
			app.renderer.render(app.stage)

		})

		app.stage.scale.x = this.scale
		app.stage.scale.y = this.scale

		return this

	},

	calcScale() {
		if (this.width < WIDTH && this.height < HEIGHT) return 1
		let hScale = 100 / (WIDTH / this.width) / 100
		let vScale = 100 / (HEIGHT / this.height) / 100
		let scale = Math.round(Math.max(hScale, vScale) * 100) / 100
		return scale
	},

	preload() {
		if (this.loading) return
		this.loading = true
		return new Promise((resolve, reject) => {
			PIXI.Loader.shared
				.add('water', require('@/assets/water.png'))
				.add('water-blur', require('@/assets/water_blur.png'))
				.add('ripple', require('@/assets/ripple.png'))
				.add('clouds', require('@/assets/clouds.jpg'))
				.add('colors', require('@/assets/colors.jpg'))
				.add('colors-mobile', require('@/assets/colors-mobile.jpg'))
				.add('mask', require('@/assets/mask.jpg'))
				.add('bg1', require('@/assets/bg1.png'))
				.add('bg2', require('@/assets/bg2.png'))
				.add('bg3', require('@/assets/bg3.png'))
				.add('bg4', require('@/assets/bg4.png'))
				.load((loader, assets) => {
					this.loading = false
					resolve(assets)
				})
		})
	},

	destroyRipple(i) {
		this.ripples[0].sprite.destroy()
		this.ripples.splice(i, 1)
		this.stage.filters.splice(i + 1, 1)
	},

	addRipple(x, y) {
		let ripple = new Ripple(x, y, this.assets['ripple'].texture)
		this.stage.addChild(ripple.sprite)
		this.ripples.push(ripple)
		// if (this.ripples.length > 40) this.destroyRipple(0)
		this.applyFilters()
	},

	applyFilters() {

		this.stage.filters = this.ripples.map(r => r.filter)
		this.stage.filters.unshift(this.clouds.filter)

	},

	calcPosition(x, y) {
		if (this.mobile) {

			let pos = 0
			let halfW = this.width / 2
			let halfH = this.height / 2
			if (x < halfW && y < halfH) pos = 2
			if (x > halfW && y < halfH) pos = 3
			if (x < halfW && y > halfH) pos = 1
			if (x > halfW && y > halfH) pos = 0
			if (pos !== this.lastPos) this.lastPos = pos

		} else {

			let width = this.width / 4
			let pos = Math.floor(x / width)
			if (pos !== this.lastPos) this.lastPos = pos

		}

	},

	showPreload() {

		if (this.loading) return
		this.loading = true
		this.disabled = true

		let bg = this[`bg${this.lastPos + 1}`]

		Events.$emit('water-start')

		new Tween({
			x: this.mask.position.x,
			y: this.mask.position.y,
			scale: this.mask.scale.x,
			opacity: 0,
		})
		.to({
			x: this.width / 2 / this.scale,
			y: this.height / 2 / this.scale,
			scale: this.mask.scale.x + 0.5,
			opacity: 1,
		}, 500)
		.on('update', ({x, y, scale, opacity}) => {
			this.mask.position.set(x, y)
			this.mask.scale.set(scale)
			this.blur.alpha = opacity
			bg.alpha = opacity
		})
		.on('complete', () => {

			setTimeout(() => {

				Events.$emit('water-end')

				new Tween({a: 0.8})
					.to({a: 0}, 500)
					.on('update', ({ a }) => {
						this.mask.alpha = a
						this.blur.alpha = a
					})
					.on('complete', () => {
						this.blur.alpha = 0
						bg.alpha = 0
					})
					.start()
				
				this.timeout = null
				this.loading = false
				this.next(this.lastPos)

			}, 3000)

		})
		.start()

	},

	hidePreload() {
		this.loading = false
	},



}
